export default __webpack_public_path__ + "images/ba364175feb4f6d2429a33959bc0b804.svg";